'use strict';

const _state = {
    registry: new Map(), // key: gridID, value: options,
};

const _config = {
    defaultDebouncewait: 200,
    showDelay: 0,
};

const debouncedRunAll = debounce(() => {

    const minWidth = 400;

    // Delay showing until after resize settles
    const showDelay = _config.showDelay || 0;

    setTimeout(() => {

        // Resize All Registered Grids
        _state.registry.forEach((opts, id) => {
            try {

                const newWidth = doResizeFor(id, opts);
                // store newWidth back into object options
                // -1 indicates to do not resize at all
                if (newWidth !== -1 && newWidth < minWidth){
                    newWidth = minWidth;
                }

                opts.newWidth = newWidth;

            } catch (err) {
                console.error('GridResizer error for', id, err);
            }
        });

        // Resize all Registered Grids
        _state.registry.forEach((opts, id) => {

            if (_state.registry.get(id).newWidth > -1){
                $('#' + id).jqGrid('setGridWidth', _state.registry.get(id).newWidth);
            }

        });
    }, showDelay);

}, _config.defaultDebouncewait);

$(window).bind('resize', debouncedRunAll);

function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

function doResizeFor(gridID, opts = {}) {
    const minWidth = typeof opts.minWidth === 'number' ? opts.minWidth : 400;
    const iOSMinWidth = 800;
    const beforeResize = opts.beforeResize;
    const onComplete = opts.onComplete;
    const widthReduction = typeof opts.widthReduction === 'number' ? opts.widthReduction : 0;
    let newWidth;

    const gridEl = $('#' + gridID);
    if (!gridEl || gridEl.length === 0) {
        return;
    }

    // setGridWidth during inline edit strips the editors
    try {
        const savedRow = gridEl.jqGrid('getGridParam', 'savedRow');
        if (savedRow && savedRow.length) {
            return -1;
        }
    } catch (err) {}

    if (typeof beforeResize === 'function') {
        try {
            beforeResize();
        } catch (err) {
            console.error('beforeResize error for', gridID, err);
        }
    }

    // Check if grid is in p_window

    var isInsidePWindow = gridEl.closest('#p_window').length > 0;
    // eslint-disable-next-line max-len
    var isDialogGen = gridEl.closest('#dialogGen').length > 0 || gridEl.closest('.ui-dialog').length > 0;
    var jqmWindow = gridEl.closest('.jqmWindow').length > 0;

    if (isInsidePWindow || isDialogGen || jqmWindow){
        return -1;
        // const $pWin = $('#p_window');
        // newWidth = $pWin.width() - ($pWin.outerWidth() - $pWin.width());
        // newWidth -= widthReduction;
        // return newWidth;
    }

    const windowWidth = window.innerWidth;
    const $sideBar = $('#sideBarPrimaryNav');
    const sideBarWidth = ($sideBar.length && $sideBar.is(':visible')) ? ($sideBar.width() || 0) : 0;
    const parentTabPanel = gridEl.closest('.ui-tabs-panel');

    let contentPadding = $('main .content').css('padding-left') || '0';
    contentPadding = parseInt(contentPadding, 10) || 0;
    let contentPadding2 = $('main .main_content .container').css('padding-left') || '0';
    contentPadding2 = parseInt(contentPadding2, 10) || 0;

    const maxContentWidth = windowWidth - sideBarWidth - contentPadding - contentPadding2;


    // Window Only Method
    const useWindowOnlyMethod = true;

    if (useWindowOnlyMethod){
        newWidth = windowWidth;
        newWidth -= sideBarWidth;
        newWidth -= (contentPadding + contentPadding2);
        if (parentTabPanel.length > 0){
            const tabPadding = (parentTabPanel.outerWidth() - parentTabPanel.width()) || '0';
            newWidth -= Math.ceil(tabPadding);
        }

        // Check if grid is in half column (e.g.stallion contract)
        const $halfColumn = gridEl.closest('.column.is-half');
        if ($halfColumn.length > 0) {
            const $prevCol = $halfColumn.prevAll('.column.is-half').first();
            console.log('Resize: Sibling width method.');
            if ($prevCol && $prevCol.length > 0){
                newWidth = $prevCol.width();
            } else {
                newWidth = (newWidth / 2);
            }

        } else {
            newWidth -= 102;
        }

        newWidth -= widthReduction;

        if (newWidth > maxContentWidth) newWidth = maxContentWidth;

        // Give larger min width for iOS full window grids due to zoom bug
        if (window.EQLAPP.iPadDevice && $halfColumn.length < 1){
            if (newWidth < iOSMinWidth) newWidth = iOSMinWidth;
        } else {
            if (newWidth < minWidth) newWidth = minWidth;
        }

        return newWidth;
    }

    // Accurate but causes flashing

    // // Column Container
    // const columnParent = gridEl.closest('.column');
    // if (columnParent.length > 0) {
    //     newWidth = columnParent.width();
    // }

    // // Fieldset Container
    // if (!newWidth) {
    //     const fieldsetParent = gridEl.closest('fieldset');
    //     if (fieldsetParent.length > 0) {
    //         newWidth = fieldsetParent.width();
    //     }
    // }

    // Main Content (Will always exist)
    if (!newWidth) {
        const mainContainer = gridEl.closest('#main_content_container');
        if (mainContainer.length > 0) {
            newWidth = mainContainer.width();

            // Check if grid is inside a tab (adjust padding if needed)
            if (newWidth > minWidth) {
                //const parentTabPanel = gridEl.closest('.ui-tabs-panel');
                if (parentTabPanel.length > 0) {
                    let tabPadding = parentTabPanel.css('padding-left') || '0';
                    tabPadding = parseInt(tabPadding, 10) || 0;
                    newWidth -= (tabPadding * 4);
                }
            }
        }
    }

    if (!newWidth) newWidth = minWidth;
    newWidth -= widthReduction;
    if (newWidth > maxContentWidth) newWidth = maxContentWidth;
    if (newWidth < minWidth) newWidth = minWidth;

    if (typeof onComplete === 'function') {
        try {
            onComplete(newWidth, gridEl);
        } catch (err) {
            console.error('onComplete error for', gridID, err);
        }
    } else {
        try {
            //gridEl.jqGrid('setGridWidth', newWidth);
        } catch (err) {
            console.error('jqGrid setGridWidth error for', gridID, err);
        }
    }

    return newWidth;
}

export function forceResize(){
    // Only currently added for side bar nav
    // Check with someone before calling it from anywhere else!
    debouncedRunAll();
}

export function resizeNow(gridID) {
    if (!gridID) {
        return;
    }

    const opts = _state.registry.get(gridID) || {};
    const minWidth = 400;

    try {
        let newWidth = doResizeFor(gridID, opts);
        if (newWidth === -1 || typeof newWidth !== 'number') {
            return;
        }
        if (newWidth < minWidth) {
            newWidth = minWidth;
        }
        $('#' + gridID).jqGrid('setGridWidth', newWidth);
    } catch (err) {
        console.error('GridResizer resizeNow error for', gridID, err);
    }
}

export function register(options = {}) {
    if (!options || !options.gridID) {
        throw new Error('GridResizer.register requires options.gridID');
    }
    _state.registry.set(options.gridID, options);

    if (!options || !options.forceDebounce) {
        // Only use this if need resize to be called on register, avoid if possible
        debouncedRunAll();
    }

    return options.gridID;
}

export function print(){
    console.log('Printing registered grids');
    _state.registry.forEach((opts, id) => {
        try {
            console.log(id);
        } catch (err) {
            console.error('GridResizer error for', id, err);
        }
    });
}

export function darkModeSettingsInit({
    itemSelector } = {}){

    $(itemSelector).bind('click', function(event){
        event.preventDefault();
        let newTheme,
            darkModeSetting;
        const currentTheme = document.documentElement.getAttribute('data-theme');

        if (currentTheme === 'dark'){
            newTheme = 'light';
            $(this).find('.dark-mode-button')
                .addClass('dark-mode-sun')
                .removeClass('dark-mode-moon');
            darkModeSetting = 'off';
        } else {
            newTheme = 'dark';
            $(this).find('.dark-mode-button')
                .addClass('dark-mode-moon')
                .removeClass('dark-mode-sun');
            darkModeSetting = 'on';
        }

        // Save to user preference so is set for new page loads
        setMiscSetting('theme-dark-mode',darkModeSetting,'',true);

        // Switch page to new theme
        document.documentElement.setAttribute('data-theme', newTheme);

    });
}

export function miscSettingsOnCellSelect({
    gridID = '',
    rowid = '',
    editId = '',
    itemNameField = '',
    setupType = '',
    event = '',
    popupWidth = 400,
}){

    const $cell = $(event.target);
    const rowData = $('#' + gridID).jqGrid('getRowData', rowid);
    const itemName = rowData[itemNameField];
    const popEditID = (editId.length > 0) ? editId : rowid;

    // Edit
    if ($cell.hasClass('js-edit-item')) {
        pop_win(
            'ajax_generic_window.cfm',
            setupType,
            popEditID,
            'updateField',
            '',
            true,
            '',
            '',
            'Edit Setting',
            popupWidth,
            '',
        );
        return false;
    }

    // Delete
    if ($cell.hasClass('js-delete-item')) {
        const deleteMsg = 'Delete this item? \n' + itemName;

        deleteItem(
            deleteMsg,
            setupType,
            rowid,
            'row_' + rowid,
        );
        return false;
    }
}